import { ca } from '@cian/analytics';

import { EReaction } from '../../repositories/cian-chat-bot/entities/offer_reaction/OfferReactionSchema';

export const trackLike = (offerId: number, reaction?: EReaction) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: reaction === EReaction.Like ? 'Click_sopr' : 'Remove_sopr',
    label: 'Good',
    page: {
      extra: {
        chat_id: 'chatbot',
      },
    },
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: 1,
      },
    ],
  });
};

export const trackDislike = (offerId: number, reaction?: EReaction) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: reaction === EReaction.Dislike ? 'Click_sopr' : 'Remove_sopr',
    label: 'Bad',
    page: {
      extra: {
        chat_id: 'chatbot',
      },
    },
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: 1,
      },
    ],
  });
};
